<!-- TODO Wrap in new (to be implemented modal compontent for quit prevention) -->
<div class="modal-header">
  <h4 class="modal-title">{{ 'dataconnection.singular' | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    (click)="modalRef.close()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12 form-group">
      <label for="data-connection-type">{{
        'dataconnection.type' | translate
      }}</label>
      <p-select
        inputId="data-connection-type"
        [(ngModel)]="value.dataConnectionHandler"
        [options]="selectableTypes"
        [placeholder]="'dataconnection.select-type' | translate"
        [fluid]="true"
      >
        <ng-template let-item pTemplate="selectedItem">
          {{ 'dataconnection.' + item | translate }}
        </ng-template>
        <ng-template let-item pTemplate="item">
          {{ 'dataconnection.' + item | translate }}
        </ng-template>
      </p-select>
    </div>
    @switch (value.dataConnectionHandler) {
      @case (DataConnectionType.CSVDataConnection) {
        <app-csv-form #csvForm [value]="asCsvDataConnection()"></app-csv-form>
      }
      @case (DataConnectionType.HttpDataConnection) {
        <app-http-form
          #httpForm
          [value]="asHttpDataConnection()"
          [isTemplate]="isTemplate"
          (saveEvent)="save($event.valueOf())"
        ></app-http-form>
      }
      @case (DataConnectionType.SortingDataConnection) {
        <app-sorting-form [value]="value" [isTemplate]="isTemplate" />
      }
    }
  </div>
  <app-error [error]="error"></app-error>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="modalRef.close()"
  >
    {{ 'close' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!getCurrentForm() || loading"
    (click)="save()"
    [ladda]="loading"
  >
    {{ 'save' | translate }}
  </button>
</div>
